
export default function routes($stateProvider) {

	$stateProvider
		.state('surveyEditPage', {
			url:     '/survey/:id',
			resolve: {
				loggedIn: ['User', function (User) {
					return User.requireLogin();
				}],
				survey: ['Survey', '$stateParams', function (Survey, $stateParams) {
					return Survey.get($stateParams.id);
				}]
			},
			template: require('./surveyForm.html'),
			controller: 'SurveyFormController',
			controllerAs: 'surveyForm'
		});

}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/surveyForm/surveyForm.routes.js